
























































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { UploadVaultFile } from "@/types";
import BaseButton from "@/components/BaseButton";
import InfiniteScroll from "@/components/InfiniteScroll";
import { PurchasedFilesMap, SentFilesMap } from "../../types";
import VaultFiles from "../VaultFiles";

export default defineComponent({
  name: "VaultFilesList",
  components: { InfiniteScroll, BaseButton, VaultFiles },
  props: {
    vaultFiles: { type: Array as () => UploadVaultFile[], required: true },
    scroll: { type: Boolean },
    multiSelection: { type: Boolean, default: false },
    purchasedFileMap: { type: Object as PropType<PurchasedFilesMap> },
    sentFileMap: { type: Object as PropType<SentFilesMap> },
    maxFiles: { type: Number, required: false },
    stickyButtons: { type: Boolean, default: true },
    showFilesCaption: { type: Boolean, default: false },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const checkedFiles = ref<Record<string, boolean | undefined>>({});

    const fileClasses = computed(() => {
      return Object.fromEntries(
        Object.entries(checkedFiles.value).map(i => [i[0], i[1] ? "vault-file-list__file __checked" : ""])
      );
    });
    const emptySelection = computed(() => Object.values(checkedFiles.value).every(i => !i));

    const checkedFileList = computed(() => props.vaultFiles.filter(f => checkedFiles.value[f.id]));

    const onToggle = (id: string) => {
      if (props.maxFiles && !checkedFiles.value[id] && checkedFileList.value.length >= props.maxFiles) return;
      checkedFiles.value = {
        ...checkedFiles.value,
        [id]: !checkedFiles.value[id],
      };
    };

    const isChecked = (id: string) => !!checkedFiles.value[id];

    const onFileCheck = (file: UploadVaultFile) => {
      if (props.multiSelection) {
        onToggle(file.id);
      } else {
        emit("select", [file]);
      }
    };

    const onSubmit = () => {
      emit("select", checkedFileList.value);
    };
    const onCancel = () => {
      checkedFiles.value = {};
      emit("cancel");
    };
    const onMove = (): void => {
      emit("move:files", checkedFileList.value);
    };

    emit("hasSelection", false);
    watch(emptySelection, emptySelection => emit("hasSelection", !emptySelection));

    return {
      isChecked,
      onFileCheck,
      fileClasses,
      emptySelection,
      onSubmit,
      onCancel,
      onMove,
      checkedFiles,
      checkedFileList,
    };
  },
});
